export function undefinedToNull<T>(value: T | undefined): T | null {
  if (value !== undefined) {
    return value;
  }

  return null;
}
